import {getFirebase} from "@misc/utils/use-start-firebase";

export default function useFirestore() {
    const firebase = getFirebase()
    return firebase.firestore();
}
